var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuperUserIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 15.0833C17.5001 16.6941 16.1942 18 14.5834 18C12.9726 18 11.6667 16.6941 11.6667 15.0833C11.6667 13.4725 12.9726 12.1666 14.5834 12.1666C16.1942 12.1666 17.5001 13.4725 17.5001 15.0833Z",
    stroke: "#313131",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 9.66663H18.3334",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 9.66671L3.84476 7.6207C4.29948 5.8018 4.52684 4.89235 5.205 4.36286C5.88315 3.83337 6.82059 3.83337 8.69547 3.83337H11.3044C13.1792 3.83337 14.1167 3.83337 14.7948 4.36286C15.473 4.89235 15.7004 5.8018 16.1551 7.6207L16.6666 9.66671",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 15.0833C8.33333 16.6941 7.0275 18 5.41667 18C3.80584 18 2.5 16.6941 2.5 15.0833C2.5 13.4725 3.80584 12.1666 5.41667 12.1666C7.0275 12.1666 8.33333 13.4725 8.33333 15.0833Z",
    stroke: "#313131",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 15.0833L8.88188 14.809C9.5857 14.4571 10.4141 14.4571 11.118 14.809L11.6666 15.0833",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperUserIcon);
export default __webpack_public_path__ + "static/media/SuperUserIcon.925eb387c74291981810e5ea64f37f7d.svg";
export { ForwardRef as ReactComponent };